module.exports = __webpack_public_path__ + "static/media/upp_flo_edg_pro.ea1665ac.png";